import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type {
  ApiResponseMachineEntity,
  CreateMachineRequest,
} from "../../shared/types/api";

export class MachineApiService {
  async createMachine(
    routerId: number,
    request: CreateMachineRequest,
  ): Promise<ApiResponseMachineEntity> {
    const response = await httpClient.post<ApiResponseMachineEntity>(
      NEW_API_ENDPOINTS.machineController.POST(routerId),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "기계 생성 실패.");
    }

    return response.data;
  }
}

export const machineApiService = new MachineApiService();
